// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RMK91","left":"styles_left__1fiXH","desktopActions":"styles_desktopActions__2QotL","title":"styles_title__14Ary"};